module.exports = __webpack_public_path__ + "img/session3_2.63318d64.png";